import React, { Component } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Route, Redirect, Switch, withRouter } from 'react-router';
import { withAuth } from '@okta/okta-react';
import { routines as modalRoutines } from '../../reducers/ui/modal';
import Loading from '../../components/shared/Loading';
import Modals from '../Modals';
import Menu from '../Menu';
import Dashboard from '../Dashboard';
import UserMenu from './UserMenu';
import './style.css';
import { routines as userRoutines } from '../../reducers/db/user';

import {
  routines as decisionsActions,
  isDealsForGpListLoadingSelector,
  dealsForGpListSelector
} from '../../reducers/db/decisions';
import { find } from 'lodash';

class App extends Component {
  state = {
    hasShownDisclosures: false,
    isPolling: false
  };

  async componentDidMount() {
    document.addEventListener('keydown', this.handleKeyPress, false);
    const gpemail = window.localStorage.getItem('active-user-id');
    this.props.getDealsForGpList({ email: gpemail });
  }

  componentDidUpdate() {
    const dealId = localStorage.getItem('dealId');
    if (!dealId) {
      this.handleChangeDeal();
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyPress, false);
  }

  handleKeyPress = e => {
    if (e.keyCode === 27) {
      this.props.closeModal();
    }
  };

  handleChangeDeal = () => {
    this.props.openModal({
      name: 'change-deal',
      data: {},
      display: {
        opacity: 0.2,
        height: 360,
        width: 420,
        preventAutoClose: true
      }
    });
  };
  handleShowDisclosures = () => {
    this.setState(
      {
        hasShownDisclosures: true
      },
      () => {
        this.props.openModal({
          name: 'disclosures',
          data: {},
          display: {
            opacity: 0.2,
            height: 500,
            width: 900,
            preventAutoClose: true
          }
        });
      }
    );
  };
  handleLogout = async () => {
    localStorage.clear();
    this.props.auth.logout('/logout');
    setTimeout(() => {
      document.location.reload();
    }, 1000);
  };
  handleCloseRedirect = () => {
    const { history } = this.props;
    history.replace({
      pathname: history.pathname,
      search: ''
    });
  };
  render() {
    const { isLoading, dealsForGpList } = this.props;
    const dealList = dealsForGpList.dealsForGpList || {};
    const activeDeal = find(
      dealList,
      deal => deal.salesforceDealID === window.localStorage.getItem('dealId')
    );
    const loadingClassList = classNames('app-loading', {
      'app-loading-hidden': !isLoading
    });
    return (
      <div className="app">
        <div className={loadingClassList}>
          <Loading className="app-loading-indicator" />
        </div>
        {!isLoading && (
          <div className="app-views">
            <div className="app-toolbar">
              <div className="app-toolbar-logo" />
              <div className="app-toolbar-date-picker">
                <div className="app-toolbar-date-picker-label"></div>
              </div>
              <div className="app-toolbar-badge">
                <UserMenu
                  title={window.localStorage.getItem('active-user-id')}
                />
                <div className="app-toolbar-badge-info">
                  <div
                    className="app-toolbar-badge-title"
                    title={activeDeal ? activeDeal.dealName : 'No Deal'}>
                    {activeDeal ? activeDeal.dealName : 'No Deal'}
                  </div>
                  <div
                    className="app-toolbar-badge-subtitle"
                    title={window.localStorage.getItem('section')}>
                    {window.localStorage.getItem('section')}
                  </div>
                </div>
                <div
                  className="app-logout-button"
                  onClick={this.handleLogout}
                  title="Logout">
                  <i className="fas fa-sign-out-alt" />
                </div>
              </div>
            </div>
            <Switch>
              <Redirect from="/" exact to="/dashboard" />
              <Route path="/dashboard" exact component={Dashboard} />
              <Route path="/dashboard/:sectionId" component={Dashboard} />
            </Switch>
          </div>
        )}
        <Modals className="app-modals" />
        <Menu
          className="app-menu"
          deals={dealsForGpList}
          dealId={localStorage.getItem('dealId')}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    isDealsForGpListLoading: isDealsForGpListLoadingSelector(state, props),
    dealsForGpList: dealsForGpListSelector(state, props)
  };
};

const mapDispatchToProps = {
  getCurrentUser: userRoutines.getCurrentUser,
  openModal: modalRoutines.openModal,
  closeModal: modalRoutines.closeModal,
  getDealsForGpList: decisionsActions.getDealsForGpList
};

export default withAuth(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(App))
);
